<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
// import axios from 'axios'
const query = ref('')
const results = ref([])
const loading = ref(false)
const searched = ref(false)
const router = useRouter()

const search = async () => {
  if (!query.value.trim()) return

  router.push({ path: '/search', query: { search: query.value } })

  loading.value = true
  searched.value = true
  results.value = []

/*  try {
    const response = await axios.get('https://fixstyle.ir/api/Search', {
      params: {
        search: query.value
      }
    })

    results.value = response.data.results // فرض بر اینکه نتایج در `results` هست

    console.log(response.data.data)
  } catch (error) {
    console.error('خطا در جستجو:', error)
  } finally {
    loading.value = false
  }*/
}

const user = computed(() => store.getters.getUser)
// const cartCount = computed(() => store.getters.cartCount)
const cartCount = computed(() => store.getters['cart/cartCount'])

function logout() {
  store.commit('setUser', null)
}

</script>

<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
<!--      <a class="navbar-brand" href="#">فروشگاه اینترنتی</a>-->
      <RouterLink class=" navbar-brand" to="/" >فروشگاه اینترنتی</RouterLink>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
<!--            <a class="nav-link active" aria-current="page" href="#">صفحه اصلی</a>-->
            <RouterLink class="nav-link active" to="/shop" >صفحه اصلی</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink class="nav-link" to="/products" >دیجیتال</RouterLink>
          </li>
          <li class="nav-item">
<!--            <a class="nav-link" href="#">خدمات</a>-->
            <RouterLink class="nav-link" to="/contact" >خدمات</RouterLink>


          </li>
          <li class="nav-item">
            <RouterLink class="nav-link" to="/About" >الکتریکی</RouterLink>
          </li>

          <li v-if="user" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
               aria-expanded="false">
              {{ user.name }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li>
<!--                <a class="dropdown-item" href="#">الکتریکی</a>-->
                <RouterLink class="nav-link" to="/Dashboard" >داشبورد</RouterLink>
              </li>
              <li>
<!--                <a class="dropdown-item" href="#">دیجیتال</a>-->
                <RouterLink class="nav-link" to="/About" >تنظیمات</RouterLink>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <a class="dropdown-item" @click="logout" >خروج</a>
<!--                <RouterLink class="nav-link" to="/About"  >خروج</RouterLink>-->

              </li>
            </ul>
          </li>
          <li v-else  class="nav-item mx-3">

<!--            <RouterLink  class="nav-link" to="/Dashboard" >   داشبورد / {{ user.name }}</RouterLink>-->
            <a  class="  btn btn-outline-dark " href="/login" tabindex="-1" aria-disabled="true"> ورود/ثبت نام</a>
          </li>
<!--          <li class="nav-item">
            <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">ثبت نام</a>
          </li>-->
        </ul>
        <RouterLink to="/cart" class="nav-link">

          <a href="#" class="mx-2 position-relative">
            <span class="border-2 border-left pl-2">
              <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.4375 17.3125C6.4375 16.415 7.16504 15.6875 8.0625 15.6875C8.95996 15.6875 9.6875 16.415 9.6875 17.3125C9.6875 18.21 8.95996 18.9375 8.0625 18.9375C7.16504 18.9375 6.4375 18.21 6.4375 17.3125Z" fill="#000"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.375 17.3125C15.375 16.415 16.1025 15.6875 17 15.6875C17.8975 15.6875 18.625 16.415 18.625 17.3125C18.625 18.21 17.8975 18.9375 17 18.9375C16.1025 18.9375 15.375 18.21 15.375 17.3125Z" fill="#000"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0.75 1.0625C0.75 0.613769 1.11377 0.25 1.5625 0.25H4.8125C5.19976 0.25 5.5332 0.523313 5.6092 0.903041L6.2916 4.3125H19.4375C19.6796 4.3125 19.9092 4.4205 20.0635 4.60708C20.2179 4.79365 20.281 5.03934 20.2356 5.2772L18.9345 12.1002C18.823 12.6613 18.5177 13.1653 18.0721 13.524C17.6287 13.881 17.0744 14.0714 16.5055 14.0625H8.62202C8.05306 14.0714 7.49879 13.881 7.05539 13.524C6.60995 13.1654 6.30477 12.6617 6.19321 12.1009C6.19316 12.1006 6.19325 12.1011 6.19321 12.1009L4.83589 5.31935C4.83039 5.29692 4.82581 5.27412 4.82221 5.251L4.14651 1.875H1.5625C1.11377 1.875 0.75 1.51123 0.75 1.0625ZM6.61684 5.9375L7.78693 11.7836C7.82408 11.9706 7.92583 12.1386 8.07437 12.2582C8.22291 12.3778 8.40878 12.4413 8.59943 12.4376L8.615 12.4375H16.5125L16.5281 12.4376C16.7187 12.4413 16.9046 12.3778 17.0531 12.2582C17.201 12.1392 17.3025 11.9722 17.34 11.7862L18.4554 5.9375H6.61684Z" fill="#000"></path></svg>
            </span>
            <span class="fa-layers-counter2 fa-2x font-weight-bolder">{{cartCount}}</span>
          </a>


        </RouterLink>
        <form class="d-flex " @submit.prevent="search">
          <input v-model="query" class="form-control me-2" type="search" placeholder="جستجو" aria-label="Search" name="Search" required>
          <button class="btn btn-outline-success" type="submit" >جستجو</button>
        </form>
      </div>
    </div>
  </nav>
</template>

<style scoped>

</style>